import React from 'react'
import BaseComponent from "../../pages/base/BaseComponent";
import PropTypes from "prop-types";
import {isEmpty} from "enqc-utilities/src/utils/Utilities";
import {Card, Col, Row} from "@themesberg/react-bootstrap";
import label from "enqc-utilities/src/label/Label";
import {faCode} from "@fortawesome/free-solid-svg-icons";
import TextInput from "../input/TextInput";

export default class ControllerFWVersionHistoryCard extends BaseComponent{


    render() {
        let {assemblyHistory} = this.props
        if(isEmpty(assemblyHistory)){
            assemblyHistory = {}
        }
        let {headerClassName} = this.props
        return (
            <Card border="light" className="bg-white shadow-sm mb-4">
                <Card.Header className={headerClassName}>
                    {label.FWVersion} {label.And} {label.Controller}
                </Card.Header>
                <Card.Body>
                    <Row>
                        <Col xs={12} lg={12} className="text-left">
                            <TextInput
                                label={label.FWVersion}
                                icon={faCode}
                                readOnly={true}
                                value={assemblyHistory.fwVersion}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} lg={12} className="text-left">
                            <TextInput
                                label={label.Controller}
                                icon={faCode}
                                readOnly={true}
                                value={assemblyHistory.controller}
                            />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        );
    }

}

ControllerFWVersionHistoryCard.propTypes = {
    assemblyHistory : PropTypes.any,
    headerClassName: PropTypes.string
}